import { Component, OnInit, Input } from '@angular/core';
// Ngb
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-denegar',
  templateUrl: './denegar.component.html',
  styleUrls: ['./denegar.component.css']
})
export class DenegarComponent implements OnInit {
  razon: string;
  @Input() tipo: any;
  @Input() accion: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  denegar() {
    if (this.razon) {
      this.activeModal.close(this.razon);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/denegar/denegar.component.ts